import * as React from 'react'

const GroupsLIstNavbar = ({ title }: { title: string }) => {
  return (
    <div className="tw-bg-gray-100 tw-px-4 tw-pb-1.5 tw-pt-2.5 tw-text-xs tw-font-medium tw-uppercase tw-text-content-base/80">
      {title}
    </div>
  )
}

export default GroupsLIstNavbar
